import { DynamoDBClient, PutItemCommand } from '@aws-sdk/client-dynamodb';
import { fetchAuthSession } from 'aws-amplify/auth';

// DynamoDB helper — writes newsletter emails via SDK v3.

const cfg = window.heku_aws_config;

// Write email to DynamoDB. Skips duplicates via localStorage guard
export async function addEmailToDynamoTable(email, federatedIdentityId, provider) {
  const KEY_SEND = 'emailIsSend';
  const isSent = localStorage.getItem(KEY_SEND);
  if (isSent && isSent === email) return;

  try {
    const { credentials } = await fetchAuthSession();
    const client = new DynamoDBClient({
      region: cfg.Region,
      credentials
    });

    await client.send(
      new PutItemCommand({
        TableName: cfg.DYNAMO_TABLE,
        Item: {
          email: { S: email },
          federated_identity_id: { S: federatedIdentityId },
          provider: { S: provider }
        }
      })
    );

    localStorage.setItem(KEY_SEND, email);
  } catch {}
}
